<ng-container *ngIf="currentNews.length !== 0">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-10">
        <carousel>
          <slide *ngFor="let appnews of currentNews">
            <div class="alert alert-warning pl-5 pr-5 pb-5 pt-5" role="alert">
              <div class="container">
                <div class="row align-items-start">
                  <div class="col-1"></div>
                  <div class="col-10">
                    <h4 class="alert-heading">{{appnews.newstitle}}</h4>
                    <div [innerHTML]="appnews.newscontent"></div>
                  </div>
                  <div class="col-1"></div>
                </div>
              </div>
            </div>
          </slide>
        </carousel>
      </div>
    </div>
  </div>
</ng-container>
